import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center tracking-tight">
          {t('faq.title')}
        </h2>

        <div className="mt-12 space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-50/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${openIndex === idx ? 'max-h-[500px] pb-5 px-5' : 'max-h-0'}`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}